/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DeliveryTimeseriesPoint = zod
	.object({
		attempts: zod.number().describe('Total delivery attempts'),
		avg_latency_ms: zod.number().nullable().describe('Average latency in ms'),
		delivered: zod.number().describe('Successful deliveries'),
		failed: zod.number().describe('Failed deliveries'),
		max_latency_ms: zod.number().nullable().describe('Maximum latency in ms'),
		min_latency_ms: zod.number().nullable().describe('Minimum latency in ms'),
		p95_latency_ms: zod.number().nullable().describe('95th percentile latency in ms'),
		ts: zod.iso.datetime({ offset: true }).describe('Bucket timestamp')
	})
	.describe('Delivery timeseries data point');

export type DeliveryTimeseriesPoint = zod.input<typeof DeliveryTimeseriesPoint>;
export type DeliveryTimeseriesPointOutput = zod.output<typeof DeliveryTimeseriesPoint>;
